<p-confirmdialog
        key="globalErrorMessage"
        [rejectVisible]="false"
        [dismissableMask]="true"
        [position]="'top'"
        [closable]="true"
        [defaultFocus]="'accept'"
        (onHide)="onHide()"
/>
